// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Payment Type Model
*/
export class EnrollmentV2PaymentTypeModel {
    /**
    * @description Payment Type Id
    */
    'paymentTypeId'?: number;
    /**
    * @description Payment Type Code
    */
    'paymentTypeCode'?: string | null;
    /**
    * @description Payment Type Description
    */
    'paymentTypeDescription'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentV2PaymentTypeModel>> = [
        {
            "name":     "paymentTypeId",
            "baseName": "paymentTypeId",
            "type":     "number"
        },
        {
            "name":     "paymentTypeCode",
            "baseName": "paymentTypeCode",
            "type":     "string"
        },
        {
            "name":     "paymentTypeDescription",
            "baseName": "paymentTypeDescription",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentV2PaymentTypeModel.attributeTypeMap;
    }
}
